import React, { useEffect, useState } from "react";
import axios from "axios";
import { baseurl } from "../Baseurl";
import {
  PieChart,
  Pie,
  Cell,
  BarChart,
  Bar,
  XAxis,
  YAxis,
  Tooltip,
  Legend,
  ResponsiveContainer,
} from "recharts";

export default function KpiDashboard() {
  const orgId = localStorage.getItem("organization_id");
  const [tasks, setTasks] = useState([]);

  const COLORS = ["#0088FE", "#00C49F", "#FFBB28", "#FF8042"];

useEffect(() => {
  const fetchData = async () => {
    try {
      const [normalRes, strategicRes] = await Promise.all([
        axios.get(`${baseurl}getProjectTaskDetailsByOrg/${orgId}`),
        axios.get(`${baseurl}getProjectTaskDetailsByOrgstretegic/${orgId}`),
      ]);

      let normalTasks = Array.isArray(normalRes.data) ? normalRes.data : [];
      let strategicTasks = Array.isArray(strategicRes.data) ? strategicRes.data : [];

      let allTasks = [...normalTasks, ...strategicTasks];

      // 🔹 Update status for overdue tasks based on timeframe
      const now = new Date();

      allTasks = allTasks.map((task) => {
        if (
          (task.status === "todo" || task.status === "in-progress") &&
          task.timeframe // ensure timeframe exists
        ) {
          const createdDate = new Date(task.created_at);
          let isOverdue = false;

          switch (task.timeframe.toLowerCase()) {
            case "daily":
              isOverdue = now > new Date(createdDate.getTime() + 1 * 24 * 60 * 60 * 1000);
              break;
            case "weekly":
              isOverdue = now > new Date(createdDate.getTime() + 7 * 24 * 60 * 60 * 1000);
              break;
            case "monthly":
              const monthEnd = new Date(createdDate);
              monthEnd.setMonth(monthEnd.getMonth() + 1);
              isOverdue = now > monthEnd;
              break;
            case "yearly":
              const yearEnd = new Date(createdDate);
              yearEnd.setFullYear(yearEnd.getFullYear() + 1);
              isOverdue = now > yearEnd;
              break;
            default:
              break;
          }

          if (isOverdue) {
            return { ...task, status: "overdue" };
          }
        }
        return task;
      });

      setTasks(allTasks);
    } catch (err) {
      console.error("❌ Error fetching tasks:", err);
    }
  };

  if (orgId) fetchData();
}, [orgId]);


  // 🔹 Calculate metrics
  const totalTasks = tasks.length;
  const completedTasks = tasks.filter(
    (t) => t.status === "complete" || t.status === "done"
  ).length;
  const incompleteTasks = tasks.filter(
    (t) => t.status === "todo" || t.status === "in-progress"
  ).length;
  const overdueTasks = tasks.filter((t) => t.status === "overdue").length;

  // 🔹 Completion chart data
  const completionData = [
    { name: "Completed", value: completedTasks },
    { name: "Incomplete", value: incompleteTasks },
    { name: "Overdue", value: overdueTasks },
  ];

  // 🔹 Priority chart (demo until backend provides priority)
  const priorityData = [
    { name: "High", value: tasks.filter((t) => t.priority === "high").length },
    { name: "Medium", value: tasks.filter((t) => t.priority === "medium").length },
    { name: "Low", value: tasks.filter((t) => t.priority === "low").length },
  ];

  return (
    <div className="container mt-4">
      <h3 className="fw-bold mb-4">📊 Task Reporting Dashboard</h3>

      {/* 🔹 Summary Cards */}
      <div className="row mb-4">
        <div className="col-md-3">
          <div className="card shadow-sm p-3 text-center">
            <h5>Total Tasks</h5>
            <h3>{totalTasks}</h3>
          </div>
        </div>
        <div className="col-md-3">
          <div className="card shadow-sm p-3 text-center">
            <h5>Completed</h5>
            <h3>{completedTasks}</h3>
          </div>
        </div>
        <div className="col-md-3">
          <div className="card shadow-sm p-3 text-center">
            <h5>Incomplete</h5>
            <h3>{incompleteTasks}</h3>
          </div>
        </div>
        <div className="col-md-3">
          <div className="card shadow-sm p-3 text-center">
            <h5>Overdue</h5>
            <h3>{overdueTasks}</h3>
          </div>
        </div>
      </div>

      {/* 🔹 Charts */}
      <div className="row">
        <div className="col-md-6">
          <div className="card shadow-sm p-3">
            <h5 className="text-center">Task Completion Chart</h5>
            <ResponsiveContainer width="100%" height={300}>
              <PieChart>
                <Pie
                  data={completionData}
                  cx="50%"
                  cy="50%"
                  outerRadius={100}
                  fill="#8884d8"
                  dataKey="value"
                  label
                >
                  {completionData.map((_, index) => (
                    <Cell key={index} fill={COLORS[index % COLORS.length]} />
                  ))}
                </Pie>
                <Tooltip />
                <Legend />
              </PieChart>
            </ResponsiveContainer>
          </div>
        </div>

        <div className="col-md-6">
          <div className="card shadow-sm p-3">
            <h5 className="text-center">Task Priority Chart</h5>
            <ResponsiveContainer width="100%" height={300}>
              <BarChart data={priorityData}>
                <XAxis dataKey="name" />
                <YAxis />
                <Tooltip />
                <Legend />
                <Bar dataKey="value" fill="#82ca9d" />
              </BarChart>
            </ResponsiveContainer>
          </div>
        </div>
      </div>
    </div>
  );
}
